import type { AgChartOptions } from "ag-charts-community";
import { useMemo } from "react";

import { Chart } from "@web-app/components";

import ChartWrapper from "./ChartWrapper";

interface PieChartData {
  datasets: Array<{
    backgroundColor?: string[];
    data: number[];
  }>;
  labels: string[];
}

interface PieChartProps {
  data: PieChartData;
  title: string;
}

export default function PieChart({ data, title }: PieChartProps) {
  const chartData = useMemo(() => {
    if (!data?.labels || !data?.datasets?.[0]?.data) return [];

    return data.labels.map((label, index) => ({
      category: label,
      value: data.datasets[0].data[index] || 0,
    }));
  }, [data]);

  const chartOptions: AgChartOptions = useMemo(
    () => ({
      data: chartData,
      series: [
        {
          angleKey: "value",
          calloutLabelKey: "category",
          sectorLabelKey: "value",
          type: "pie",
        },
      ],
    }),
    [chartData],
  );

  return (
    <ChartWrapper title={title}>
      <Chart options={chartOptions} isLoading={false} />
    </ChartWrapper>
  );
}
